import { createSelector } from "reselect"
import { get, map, mapValues } from "lodash"

const EMPTY_ARRAY = []

function flattenExposure(composites) {
  return map(composites, composite => ({
    ...composite,
    factorExposure: get(composite, "factorExposure.0.zScore"),
  }),
  )
}

const getRawExposedComposites = state => get(state, "global.data.exposedComposites.data.model", EMPTY_ARRAY)

export const getExposedComposites = createSelector(
  [getRawExposedComposites],
  (composites) => mapValues(composites, ({ securities }) => flattenExposure(securities)),
)
